export default defineNuxtPlugin(() => {
	const lazyScriptsService = useLazyScriptsService()
	const initialized = ref(false)

	const runLazyScripts = async () => {
		if (!initialized.value) {
			initialized.value = true
			await lazyScriptsService.runLazyScripts()
		}
	}

	if (process.client) {
		const timeout = setTimeout(() => {
			runLazyScripts()
		}, 5000)

		const events: (keyof DocumentEventMap)[] = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click']

		const handleUserInput = () => {
			clearTimeout(timeout)
			runLazyScripts()

			events.forEach((event) => {
				document.removeEventListener(event, handleUserInput)
			})
		}

		events.forEach((event) => {
			console.log('add event listener', event)
			document.addEventListener(event, handleUserInput)
		})
	}
})
